import { QueryClient, dehydrate } from '@tanstack/react-query';
import React from 'react';
import { LoaderFunctionArgs, useOutletContext } from 'react-router';

import { userGalleryQuery } from '~/modules/gallery/queries';

import UserGallery from './_components/UserGallery';

export default function UserGalleryIndex() {
  const { user } = useOutletContext<{ user: User }>();
  if (!user) return null;
  return <UserGallery user={user?.username} />;
}

export const loader =
  (queryClient: QueryClient) =>
  async ({ params: { username } }: LoaderFunctionArgs) => {
    await queryClient.prefetchQuery(userGalleryQuery(username, 1, false));
    return { dehydratedState: dehydrate(queryClient) };
  };
